import { useQuery } from "@tanstack/react-query";

import { getContainersOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export function useGetContainers() {
  return useQuery({
    ...getContainersOptions(),
  });
}
